import { ActivatedRouteSnapshot } from '@angular/router';

import { RouteData } from '../interfaces/app-route.interface';

export function checkRouterChildsData(
  route: ActivatedRouteSnapshot & {
    data?: RouteData;
  },
  compareWith: (data: RouteData) => boolean
): boolean {
  if (compareWith(route.data)) {
    return true;
  }

  if (!route.firstChild) {
    return false;
  }

  return checkRouterChildsData(route.firstChild, compareWith);
}
